"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ViewMediaReadStats model module.
 * @module model/ViewMediaReadStats
 * @version 1.1.3-alpha.1
 */
class ViewMediaReadStats {
  /**
   * Constructs a new <code>ViewMediaReadStats</code>.
   * @alias module:model/ViewMediaReadStats
   * @param id {String} 
   */
  constructor(id) {
    ViewMediaReadStats.initialize(this, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, id) {
    obj['id'] = id;
  }

  /**
   * Constructs a <code>ViewMediaReadStats</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ViewMediaReadStats} obj Optional instance to populate.
   * @return {module:model/ViewMediaReadStats} The populated <code>ViewMediaReadStats</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ViewMediaReadStats();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('user_count')) {
        obj['user_count'] = _ApiClient.default.convertToType(data['user_count'], 'Number');
      }
      if (data.hasOwnProperty('customer_count')) {
        obj['customer_count'] = _ApiClient.default.convertToType(data['customer_count'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ViewMediaReadStats</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ViewMediaReadStats</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of ViewMediaReadStats.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    return true;
  }
}
ViewMediaReadStats.RequiredProperties = ["id"];

/**
 * @member {String} id
 */
ViewMediaReadStats.prototype['id'] = undefined;

/**
 * @member {Number} user_count
 */
ViewMediaReadStats.prototype['user_count'] = undefined;

/**
 * @member {Number} customer_count
 */
ViewMediaReadStats.prototype['customer_count'] = undefined;
var _default = ViewMediaReadStats;
exports.default = _default;